import React from 'react';
import './AppAdsPage.css';

const AppAdsPage: React.FC = () => {
    const appAdsContent = "google.com, pub-2592279002579309, DIRECT, f08c47fec0942fa0";

    return (
        <div className="app-ads-page">
            <div className="container">
                <h1>app-ads.txt</h1>
                <div className="content">
                    <pre>{appAdsContent}</pre>
                </div>
                <div className="info">
                    <p>This file is used by advertising systems to verify authorized digital sellers.</p>
                    <a href="/" className="back-link">← Back to Home</a>
                </div>
            </div>
        </div>
    );
};

export default AppAdsPage; 